export default "__VITE_PUBLIC_ASSET__4405ed2c__"